__turbopack_context__.v({
  "body": "goJ4Pa_body",
  "body__content": "goJ4Pa_body__content",
  "body__content--placeholder": "goJ4Pa_body__content--placeholder",
  "card": "goJ4Pa_card",
  "overlay": "goJ4Pa_overlay",
  "shimmer": "goJ4Pa_shimmer",
  "tags": "goJ4Pa_tags",
  "text-bar-sweep": "goJ4Pa_text-bar-sweep",
  "title": "goJ4Pa_title",
  "title--placeholder": "goJ4Pa_title--placeholder",
});
